"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestService = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const http_1 = require("@angular/common/http");
class RestService {
    constructor(http) {
        this.http = http;
        this.baseUrl = '';
        this.genericErrorMessage = 'We were unable to retrieve this information. Please refresh the page to try again.';
    }
    prepareUrl(relativeUrl) {
        return this.baseUrl + relativeUrl;
    }
    get(relativeUrl, headers) {
        // eslint-disable-next-line max-len
        return this.http.get(this.prepareUrl(relativeUrl), { headers }).pipe(operators_1.timeoutWith(100000, rxjs_1.throwError(new Error(this.genericErrorMessage))), operators_1.map((res) => res));
    }
    getWithIncreasedTomeout(relativeUrl, timeout, headers) {
        return this.http.get(this.prepareUrl(relativeUrl), { headers }).pipe(operators_1.timeoutWith(timeout, rxjs_1.throwError(new Error(this.genericErrorMessage))), operators_1.map((res) => res));
    }
    jsonp(relativeUrl) {
        // eslint-disable-next-line max-len
        return this.http.jsonp(relativeUrl, 'callback').pipe(operators_1.map((res) => res));
    }
    post(relativeUrl, data, isJson, header) {
        let headers = new http_1.HttpHeaders();
        if (isJson) {
            headers = headers.set('Content-Type', 'application/json');
        }
        else {
            headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
        }
        if (header !== undefined) {
            headers = headers.append('Authorization', header);
        }
        //   headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
        // eslint-disable-next-line max-len
        return this.http.post(this.prepareUrl(relativeUrl), data, { headers }).pipe(operators_1.timeoutWith(100000, rxjs_1.throwError(new Error(this.genericErrorMessage))), operators_1.map((res) => res));
    }
    put(relativeUrl, data, isJson) {
        let headers = new http_1.HttpHeaders();
        if (isJson) {
            headers = headers.set('Content-Type', 'application/json');
        }
        else {
            headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
        }
        //   headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
        // eslint-disable-next-line max-len
        return this.http.put(this.prepareUrl(relativeUrl), data, { headers }).pipe(operators_1.timeoutWith(100000, rxjs_1.throwError(new Error(this.genericErrorMessage))), operators_1.map((res) => res));
    }
    delete(relativeUrl) {
        return this.http.delete(this.prepareUrl(relativeUrl)).pipe(operators_1.map((res) => res));
    }
    // Added delete call if want to send json data
    deleteJsonApplicationData(relativeUrl, data, isJson) {
        const httpOptions = {
            headers: new http_1.HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body: data
        };
        // eslint-disable-next-line max-len
        return this.http.delete(this.prepareUrl(relativeUrl), httpOptions).pipe(operators_1.timeoutWith(100000, rxjs_1.throwError(new Error(this.genericErrorMessage))), operators_1.map((res) => res));
    }
}
exports.RestService = RestService;
//# sourceMappingURL=restservice.js.map